import * as Sentry from '@sentry/react';

import config from '../config';

export const sendException = (
  exception: Parameters<typeof Sentry.captureException>[0],
  opts?: {
    tags: string[][];
  },
) => {
  if (!config.SENTRY_ENABLED) {
    return;
  }

  Sentry.withScope((scope) => {
    (opts?.tags || []).forEach(([key, value]) => {
      scope.setTag(key, value);
    });

    Sentry.captureException(JSON.stringify(exception));
  });
};
